<template>
  <el-dialog
    title="留言咨询"
    :visible="visible"
    width="420px"
    top="8vh"
    :append-to-body="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :lock-scroll="true"
    custom-class="requirement-dialog"
    @close="handleClose"
    @opened="handleOpened"
  >
    <div class="requirement-frame">
      <h3 class="requirement-frame__title">留言咨询</h3>
      <div class="requirement-frame__content">
        <consult-form
          ref="consultForm"
          :submitting="submitting"
          @submit="onSubmit"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ConsultForm from './ConsultForm.vue'

export default {
  name: 'RequirementDialog',
  components: { ConsultForm },
  data() {
    return {
      submitting: false
    }
  },
  computed: {
    ...mapState(['showRequirementDialog']),
    visible() {
      return this.showRequirementDialog
    }
  },
  methods: {
    ...mapActions(['closeRequirementDialog', 'submitRequirement']),
    handleOpened() {
      this.$nextTick(() => {
        const form = this.$refs.consultForm
        if (form) {
          form.refreshCaptcha()
        }
      })
    },
    handleClose() {
      this.closeRequirementDialog()
      this.$nextTick(() => {
        this.$refs.consultForm && this.$refs.consultForm.reset()
      })
    },
    async onSubmit(formData) {
      this.submitting = true
      try {
        await this.submitRequirement(formData)
        this.$message.success('提交成功，我们会尽快与您联系！')
        this.handleClose()
      } catch (e) {
        this.$message.error(e.message || '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss">
.requirement-dialog {
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible;

  .el-dialog__header {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2;
    padding: 0;
    border: none;
    background: transparent;

    .el-dialog__title {
      display: none;
    }

    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      z-index: 3;

      .el-dialog__close {
        color: #000;
        font-size: 25px;
        font-weight: 700;

        &:hover {
          color: #000;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 0;
    overflow: visible;
  }

  .el-dialog__footer {
    display: none;
  }
}

.requirement-frame {
  width: 100%;
  box-sizing: border-box;
  border: 38px solid transparent;
  border-image: url('~@/assets/images/message-consult-frame.png') 76 22 22 22 fill / 38px 11px 11px 11px stretch;
  filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.15));

  &__title {
    margin: 0 0 10px;
    padding: 0 0 10px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    color: $text-primary;
    border-bottom: 1px solid #f0f0f0;
  }

  &__content {
    padding: 0 20px 4px;
    max-height: 70vh;
    overflow-y: auto;
  }
}

@media (max-width: 576px) {
  .requirement-dialog {
    width: 92% !important;
    margin-top: 5vh !important;
  }

  .requirement-frame__content {
    padding: 0 12px 4px;
  }
}
</style>
